import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SalesSigningContractComponent} from "./sales-signing-contract.component";
import {PrimengModule} from "../../shared/primeng-module/primeng.module";
import {LibraryModule} from "library";
import {SalesErrorMessageModule} from "../error-message/sales-error-message.module";



@NgModule({
  declarations: [
    SalesSigningContractComponent
  ],
  imports: [
    CommonModule,
    PrimengModule,
    LibraryModule,
    SalesErrorMessageModule
  ],
  exports: [
    SalesSigningContractComponent
  ]
})
export class SalesSigningContractModule { }
